export default {
  getCardDetail: '/income/client/activity/detail'
}
